﻿import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

import { emailRegex } from 'helpers/validators';
import Button from 'components/Button';
import { TextInput } from 'components/Form';

import theme from "./ResetPasswordModal.module.sass";

const ResetPasswordModal = ({
  open,
  toggleModal,
  onSubmit,
}) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  return (
    <Modal
      className={theme.Modal}
      open={open}
      closeAfterTransition
      /*
        Keep MUI's own backdrop and only tune its timing. MUI v7's Modal styles its
        default backdrop with z-index -1, so it sits under the content. Passing the
        plain Backdrop as BackdropComponent, the v4 idiom, swapped in one with no
        z-index: v4's Backdrop carried z-index -1 itself and v5 dropped it. Any
        content that is not positioned then lost to the backdrop the moment its fade
        ended, and every click on it closed the modal instead.
      */
      slotProps={{ backdrop: { timeout: 500 } }}
      onClose={
        /* istanbul ignore next */
        () => { toggleModal(false); }
      }
    >
      <Fade in={open}>
        <form className={theme.Form} onSubmit={handleSubmit(onSubmit)}>
          <h1 className={theme.FormTitle}>Password Recovery</h1>
          {/* eslint-disable-next-line max-len */}
          <p className={theme.SectionTitle}>Enter your email below and we will send you a link to reset your password</p>
          <div className={theme.VerticalGroup}>
            <div className={theme.InputGroup}>
              <label className={theme.Label} htmlFor="email">Email</label>
              <TextInput
                id="email"
                {...register("email", {
                  required: 'Enter your email',
                  pattern: {
                    value: emailRegex,
                    message: 'Your email is not a valid email address',
                  },
                })}
                error={errors.email?.message}
              />
            </div>
          </div>
          <footer className={theme.Footer}>
            <Button size="big" color="secondary" onClick={() => { toggleModal(false); }}>Cancel</Button>
            <Button size="big" type="submit">Reset Password</Button>
          </footer>
        </form>
      </Fade>
    </Modal>
  );
};

ResetPasswordModal.propTypes = {
  open: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ResetPasswordModal.false = {
  open: false,
};

export default ResetPasswordModal;
